export default {"src":"/_next/static/media/crossWithPawOutline100_40.f0dc4168.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};